import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectAllSupporterImages} from '../../state/messages.selectors';
import { MessageImage } from '../../core/models/message-image.model';
import { Observable, Subscription } from 'rxjs';
import {ASCII_REMOTE_KEYS} from '../../core/services/remote-control.service';
import {Router} from '@angular/router';

@Component({
    selector: 'cm-image-carousel-container',
    templateUrl: './image-carousel-container.component.html',
    styleUrls: ['./image-carousel-container.component.scss'],
    standalone: false
})
export class ImageCarouselContainerComponent implements OnInit, OnDestroy {

  images$: Observable<MessageImage[]>;
  images: MessageImage[] = [];
  imageSubscription: Subscription;
  interval = 10000; // Default interval of 10 seconds

  constructor(private readonly store: Store, private readonly router: Router) { }

  ngOnInit(): void {
    this.images$ = this.store.select(selectAllSupporterImages);
    this.imageSubscription = this.images$.subscribe((images: MessageImage[]) => {
      this.images = images;
    });
  }

  ngOnDestroy(): void {
    this.imageSubscription.unsubscribe();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown($event: KeyboardEvent): boolean {
    if ($event.keyCode === ASCII_REMOTE_KEYS.back) {
      this.goToMenu();
    }
    return false;
  }

  goToMenu(): void {
    this.router.navigate(['dashboard/menu']);
  }

}
